import React, { PureComponent } from 'react';
import styles from './Swatch.module.css';
import Checkbox from 'rc-checkbox';
import moment from 'moment';
import Image from '../Image';
import { ContextMenu, MenuItem, ContextMenuTrigger } from 'react-contextmenu';

export default class Swatch extends PureComponent {
  onChecked = (e, data) => {
    const { onSelect } = this.props;
    if (!onSelect) return;
    const id = e.target.id;
    const value = e.target.checked;
    onSelect(id, value);
  };

  handleContextMenuClick = async (e, data) => {
    if (data.path) {
      const win = window.open(data.path, '_blank');
      win.focus();
      return;
    }
    if (data.assetId) {
      const win = window.open(
        `https://clara.io/editor/${data.assetId}`,
        '_blank'
      );
      win.focus();
    }
    if (data.id) {
      const { createJob } = this.props;
      const previewAttr = {
        type: 'modelPreview',
        modelId: data.id,
      };
      await createJob(previewAttr);
    }
  };

  render() {
    const { image, item, onClick, selected, catogary } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.checkBox}>
          <Checkbox
            id={item._id}
            onChange={this.onChecked}
            defaultChecked={selected}
          />
        </div>
        <ContextMenuTrigger id={item._id}>
          <Image
            alt={item.friendlyName}
            className={styles.swatch}
            image={image}
            onClick={onClick}
          />
        </ContextMenuTrigger>
        <h3 className={styles.swatchLabel}> {item.friendlyName} </h3>
        <p className={styles.swatchDate}>
          Updated {moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')}
        </p>
        {catogary === 'models' && (
          <ContextMenu className={styles.contextMenu} id={item._id}>
            <MenuItem
              className={styles.contentMenuItem}
              data={{ path: `/${catogary}/${item._id}` }}
              onClick={this.handleContextMenuClick}
            >
              <div className={styles.contentMenuItem}>View Model</div>
            </MenuItem>
            <MenuItem
              className={styles.contentMenuItem}
              data={{ path: `/${catogary}/${item._id}/preview` }}
              onClick={this.handleContextMenuClick}
            >
              <div className={styles.contentMenuItem}>View Previews</div>
            </MenuItem>
            <MenuItem
              className={styles.contentMenuItem}
              data={{ id: item._id }}
              onClick={this.handleContextMenuClick}
            >
              <div className={styles.contentMenuItem}>Render Preview</div>
            </MenuItem>
          </ContextMenu>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Swatch/index.js